/* ATP Part-Type + Shop-by-Truck menus v2 (Jul 2026).
   Zero-fetch architecture: the full menu HTML ships server-rendered inside
   inert <template> elements (see snippets/atp-ptm-data-*.liquid) and is
   stamped locally on first open. No network call = the "could not be
   loaded" failure state cannot occur for these two menus. Standalone from
   the engine menu JS by design. */
(function () {
  'use strict';

  var STYLE_ID = 'atp-ptm-styles';
  var CSS = [
    '.atp-ptm-trigger .title{color:#1e56d6;font-weight:700;}',
    '.atp-ptm-flyout{position:fixed;z-index:1200;background:#fff;border:1px solid #e6ebf4;border-top:3px solid #2d6dfc;box-shadow:0 18px 40px rgba(15,23,42,.16);display:flex;flex-direction:column;max-height:min(78vh,700px);border-radius:0 0 8px 8px;}',
    '.atp-ptm-flyout[hidden]{display:none;}',
    '.atp-ptm-head{display:flex;justify-content:space-between;align-items:flex-start;padding:16px 20px 12px;border-bottom:1px solid #eef1f8;}',
    '.atp-ptm-eyebrow{font-size:11px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#2d6dfc;margin:0 0 2px;}',
    '.atp-ptm-h{font-size:20px;font-weight:800;text-transform:uppercase;color:#0f172a;margin:0;line-height:1.2;}',
    '.atp-ptm-close{border:0;background:none;font-size:26px;line-height:1;color:#8a97b5;cursor:pointer;padding:2px 6px;}',
    '.atp-ptm-close:hover{color:#0f172a;}',
    '.atp-ptm-shell{display:grid;grid-template-columns:280px 1fr;flex:1;min-height:340px;overflow:hidden;}',
    '.atp-ptm-railhead{font-size:11px;font-weight:800;letter-spacing:.09em;text-transform:uppercase;color:#8a97b5;padding:4px 6px 8px;}',
    '.atp-ptm-rail{border-right:1px solid #eef1f8;overflow-y:auto;min-height:0;padding:14px 12px;background:#fafbfe;overscroll-behavior:contain;}',
    '.atp-ptm-rail button,.atp-ptm-brail button{display:flex;justify-content:space-between;align-items:center;gap:8px;width:100%;text-align:left;padding:10px 12px;margin:0 0 4px;border:1px solid transparent;border-radius:8px;background:none;font:700 13px/1.3 inherit;color:#1e1e1e;cursor:pointer;}',
    '.atp-ptm-rail button:hover,.atp-ptm-brail button:hover{background:#f2f5fc;color:#1e56d6;}',
    '.atp-ptm-rail button.is-active,.atp-ptm-brail button.is-active{background:#eef4ff;border-color:#2d6dfc;color:#1e56d6;}',
    '.atp-ptm-pill{flex:0 0 auto;min-width:26px;text-align:center;font-size:11px;font-weight:700;padding:2px 8px;border-radius:999px;background:#eef1f8;color:#475569;}',
    'button.is-active .atp-ptm-pill{background:#2d6dfc;color:#fff;}',
    '.atp-ptm-main-wrap{overflow-y:auto;min-height:0;padding:16px 20px 18px;overscroll-behavior:contain;}',
    '.atp-ptm-main-wrap:has(.atp-ptm-bshell){overflow:hidden;padding:0;display:flex;}',
    '.atp-ptm-main-wrap:has(.atp-ptm-bshell) .atp-ptm-panel{flex:1;min-height:0;height:100%;}',
    '.atp-ptm-bshell{display:grid;grid-template-columns:250px 1fr;height:100%;min-height:0;}',
    '.atp-ptm-brail{overflow-y:auto;min-height:0;border-right:1px solid #eef1f8;background:#fbfcff;padding:14px 12px;overscroll-behavior:contain;}',
    '.atp-ptm-brail button{font-weight:600;font-size:12.5px;padding:8px 10px;}',
    '.atp-ptm-bmain{overflow-y:auto;min-height:0;padding:16px 18px;overscroll-behavior:contain;}',
    '.atp-ptm-main-head{display:flex;justify-content:space-between;align-items:flex-end;gap:12px;margin:0 0 10px;flex-wrap:wrap;}',
    '.atp-ptm-kicker{font-size:11px;font-weight:800;letter-spacing:.09em;text-transform:uppercase;color:#8a97b5;margin:0 0 2px;}',
    '.atp-ptm-main-title{font-size:17px;font-weight:800;text-transform:uppercase;color:#0f172a;margin:0;}',
    '.atp-ptm-viewall{font-size:12px;font-weight:700;color:#1e56d6;text-decoration:none;white-space:nowrap;}',
    '.atp-ptm-viewall:hover{text-decoration:underline;}',
    '.atp-ptm-filter{width:100%;margin:0 0 12px;padding:10px 12px;border:1px solid #e6ebf4;border-radius:8px;font:400 13px/1.3 inherit;color:#1e1e1e;background:#fff;}',
    '.atp-ptm-filter:focus{outline:none;border-color:#2d6dfc;box-shadow:0 0 0 3px rgba(45,109,252,.12);}',
    '.atp-ptm-list a{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:11px 14px;margin:0 0 8px;border:1px solid #e6ebf4;border-radius:8px;background:#fff;font-size:13px;font-weight:400;color:#1e1e1e;text-decoration:none;}',
    '.atp-ptm-list a:hover{border-color:#2d6dfc;color:#1e56d6;}',
    '.atp-ptm-list a>span{flex:0 0 auto;min-width:26px;text-align:center;font-size:11px;font-weight:700;padding:2px 8px;border-radius:999px;background:#eef1f8;color:#475569;}',
    '.atp-ptm-list a:hover>span{background:#2d6dfc;color:#fff;}',
    /* v2.7 — the two menus get the same section-band treatment as "PARTS BY
       ENGINE": chunky divider above, tinted band, heavy type, rotating chevron.
       !important where the theme's drawer button resets were winning. */
    '.atp-ptm-mobile{border-top:8px solid #f1f4fb;margin-top:4px;}',
    '.atp-ptm-mobile + .atp-ptm-mobile{border-top-width:1px;margin-top:0;}',
    '.atp-ptm-mobile .atp-ptm-mobile-toggle{display:flex;justify-content:space-between;align-items:center;width:100%;padding:15px;border:0;border-bottom:1px solid #e6ebf4;background:#f4f7fd !important;font-size:14px !important;font-weight:800 !important;line-height:1.3;text-transform:uppercase;letter-spacing:.06em;color:#0f172a !important;cursor:pointer;}',
    '.atp-ptm-mobile .atp-ptm-mobile-toggle .atp-emm-mobile-arrow{color:#2d6dfc;font-size:18px;transition:transform .15s ease;}',
    '.atp-ptm-mobile .atp-ptm-mobile-toggle[aria-expanded="true"]{color:#1e56d6 !important;background:#eef4ff !important;}',
    '.atp-ptm-mobile .atp-ptm-mobile-toggle[aria-expanded="true"] .atp-emm-mobile-arrow{transform:rotate(90deg);}',
    /* keep the last rows reachable above the chat launcher */
    '.atp-ptm-mobile:last-of-type{padding-bottom:110px;}',
    '.atp-ptm-mobile-sys>button{display:flex;justify-content:space-between;align-items:center;width:100%;padding:10px 15px 10px 22px;border:0;background:none;font:800 12.5px/1.3 inherit;text-transform:uppercase;letter-spacing:.02em;color:#1e1e1e;cursor:pointer;}',
    '.atp-ptm-mobile-sys>button[aria-expanded="true"]{color:#1e56d6;}',
    '.atp-ptm-mobile-sub>button{display:flex;justify-content:space-between;align-items:center;width:100%;padding:9px 15px 9px 30px;border:0;background:none;font:700 12.5px/1.3 inherit;color:#1e1e1e;cursor:pointer;}',
    '.atp-ptm-mobile-sub>button[aria-expanded="true"]{color:#1e56d6;}',
    '.atp-ptm-mobile-links{padding:0 15px 8px 30px;}',
    '.atp-ptm-mlinks{padding:0 15px 8px 38px;}',
    '.atp-ptm-mobile-links a,.atp-ptm-mlinks a{display:flex;justify-content:space-between;gap:8px;padding:7px 0;font-size:13px;font-weight:400;color:#1e1e1e;text-decoration:none;border-bottom:1px solid #f1f4fb;}',
    '.atp-ptm-mobile-links a:last-child,.atp-ptm-mlinks a:last-child{border-bottom:0;}',
    '.atp-ptm-mobile-links a>span,.atp-ptm-mlinks a>span{flex:0 0 auto;min-width:24px;text-align:center;font-size:10.5px;font-weight:700;padding:1px 7px;border-radius:999px;background:#eef1f8;color:#475569;}',
    '.atp-ptm-mfilter{width:calc(100% - 8px);margin:6px 4px 10px;}',
    '.atp-ptm-mobile-sys>button .atp-ptm-pill,.atp-ptm-mobile-sub>button .atp-ptm-pill{margin-left:auto;}',
    '.main-menu > li.atp-ptm-topitem{flex:1 1 0%;min-width:0;display:flex;justify-content:center;}',
    '.main-menu .atp-ptm-topitem .atp-emm-trigger{background:none;border:0;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:5px;width:100%;padding:10px 6px;color:#ffffff;}',
    '.main-menu .atp-ptm-topitem .atp-emm-trigger:hover{opacity:.85;}',
    '.main-menu .atp-ptm-topitem .atp-emm-trigger .atp-emm-trigger-icon{color:#fdb819;}',
    '.main-menu .atp-ptm-topitem .atp-emm-trigger .title{color:#ffffff;max-width:none !important;overflow:visible !important;text-overflow:clip !important;white-space:nowrap;font-size:12.5px;letter-spacing:.01em;}'
  ].join('\n');

  function injectStyles() {
    if (!document.getElementById(STYLE_ID)) {
      var s = document.createElement('style');
      s.id = STYLE_ID; s.textContent = CSS;
      document.head.appendChild(s);
    }
  }

  function stamp(flyout, tplId) {
    if (flyout.childElementCount) return;
    var tpl = document.getElementById(tplId);
    if (tpl && tpl.content) flyout.appendChild(tpl.content.cloneNode(true));
  }

  function initDesktop() {
    var triggers = document.querySelectorAll('[data-ptm-open]');
    if (!triggers.length) return;
    var flyouts = { a: document.getElementById('atp-ptm-flyout-a'), b: document.getElementById('atp-ptm-flyout-b') };
    var current = null;

    /* Portal + fixed positioning: the flyout lives on <body>, immune to any
       overflow/stacking context in the header (the "only shows after you
       scroll" bug was ancestor clipping that the sticky-header state happened
       to release). Position is computed from the trigger + header container. */
    function place(fly, trigger) {
      if (fly.parentNode !== document.body) document.body.appendChild(fly);
      var anchor = document.querySelector('[data-atp-emm-desktop]') || trigger.closest('nav') || trigger;
      var a = anchor.getBoundingClientRect();
      var t = trigger.getBoundingClientRect();
      var left = Math.max(8, a.left);
      var width = Math.min(a.width, window.innerWidth - 16);
      fly.style.left = left + 'px';
      fly.style.width = width + 'px';
      fly.style.top = Math.round(t.bottom + 4) + 'px';
    }

    function closeAll() {
      Object.keys(flyouts).forEach(function (k) { if (flyouts[k]) flyouts[k].hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      current = null;
    }
    window.atpPtmCloseAll = closeAll;

    triggers.forEach(function (btn) {
      var which = btn.getAttribute('data-ptm-open');
      var fly = flyouts[which];
      if (!fly) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var wasOpen = !fly.hidden;
        closeAll();
        if (!wasOpen) {
          stamp(fly, 'atp-ptm-tpl-' + which);
          place(fly, btn);
          fly.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          current = { fly: fly, btn: btn };
        }
      });
      fly.addEventListener('click', function (e) {
        var bb = e.target.closest('[data-ptm-bsys]');
        if (bb) {
          var scope = bb.closest('.atp-ptm-panel');
          var key = bb.getAttribute('data-ptm-bsys');
          scope.querySelectorAll('.atp-ptm-brail button').forEach(function (x) { x.classList.toggle('is-active', x === bb); });
          scope.querySelectorAll('[data-ptm-bpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-ptm-bpanel') !== key; });
          return;
        }
        if (e.target.closest('[data-ptm-close]')) { closeAll(); return; }
        var rb = e.target.closest('[data-ptm-sys],[data-ptm-brand]');
        if (!rb) return;
        var k = rb.getAttribute('data-ptm-sys') || rb.getAttribute('data-ptm-brand');
        fly.querySelectorAll('.atp-ptm-rail > button').forEach(function (x) { x.classList.toggle('is-active', x === rb); });
        fly.querySelectorAll('.atp-ptm-main-wrap > [data-ptm-panel]').forEach(function (p) {
          var on = p.getAttribute('data-ptm-panel') === k;
          p.hidden = !on;
          if (on) {
            var h = fly.querySelector('[data-ptm-heading]');
            if (h) h.textContent = p.getAttribute('data-ptm-label') || rb.textContent;
          }
        });
      });
    });

    window.addEventListener('resize', function () { if (current) place(current.fly, current.btn); });
    window.addEventListener('scroll', function () { if (current) closeAll(); }, { passive: true });

    document.addEventListener('click', function (e) {
      if (!current || !current.fly.isConnected) return;
      if (e.target.closest('.atp-ptm-flyout,[data-ptm-open]')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* Relocate the two triggers into the theme's main menu row (out of the
       engine row) — real DOM nodes + MutationObserver, per ATP standards,
       so theme nav rebuilds cannot wipe them. Falls back to leaving them
       where the Liquid rendered them if the main menu is not found. */
    (function relocate() {
      var lis = Array.prototype.slice.call(document.querySelectorAll('li.atp-ptm-topitem'));
      if (!lis.length) return;
      var target = document.querySelector('.header-desktop ul.main-menu:not(.atp-emm-menu):not(#atp_engine_main_menu)');
      if (!target) return;
      function ensure() {
        lis.forEach(function (li) { if (li.parentNode !== target) target.appendChild(li); });
      }
      ensure();
      new MutationObserver(ensure).observe(target, { childList: true });
    })();
  }

  function initMobile() {
    document.querySelectorAll('[data-ptm-mobile]').forEach(function (box) {
      var toggle = box.querySelector('.atp-ptm-mobile-toggle');
      var panel = box.querySelector('.atp-ptm-mobile-panel');
      var tpl = box.querySelector('.atp-ptm-mobile-tpl');
      if (!toggle || !panel) return;
      toggle.addEventListener('click', function () {
        var opening = panel.hidden;
        if (opening && !panel.childElementCount && tpl && tpl.content) panel.appendChild(tpl.content.cloneNode(true));
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
      panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-ptm-filter]')) return;
        var sb = e.target.closest('.atp-ptm-msys');
        if (sb) {
          var wrap = sb.closest('.atp-ptm-mobile-links');
          var links = sb.nextElementSibling;
          var opening = links.hidden;
          wrap.querySelectorAll('.atp-ptm-mlinks').forEach(function (x) { x.hidden = true; });
          wrap.querySelectorAll('.atp-ptm-msys').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
          if (opening) { links.hidden = false; sb.setAttribute('aria-expanded', 'true'); }
          return;
        }
        var b = e.target.closest('.atp-ptm-mobile-sys>button');
        if (!b) return;
        var links = b.nextElementSibling;
        var opening = links.hidden;
        panel.querySelectorAll('.atp-ptm-mobile-links').forEach(function (x) { x.hidden = true; });
        panel.querySelectorAll('.atp-ptm-mobile-sys>button').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (opening) { links.hidden = false; b.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* one filter handler for everything: desktop panels and mobile accordions */
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ptm-filter]')) return;
    var q = e.target.value.trim().toLowerCase();
    var scope = e.target.parentElement.querySelector('.atp-ptm-list') || e.target.parentElement;
    scope.querySelectorAll('a:not(.atp-ptm-viewall)').forEach(function (a) {
      a.hidden = q !== '' && a.textContent.toLowerCase().indexOf(q) === -1;
    });
  });

  function init() { injectStyles(); initDesktop(); initMobile(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
